import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import Checkbox from "utils/Checkbox";
import { toast } from "react-toastify";

function EditPaymentAccountModal(props) {
  // Initialize state with default values for accountName, accountNo, and status
  const [id, setId] = useState(props?.item?.id);
  const [accountName, setAccountName] = useState(props?.item?.account_name);
  const [accountNo, setAccountNo] = useState(props?.item?.account_no);
  const [status, setStatus] = useState(props?.item?.status);
  const [types, setTypes] = useState(props?.item?.types);

  const [isLoading, setIsLoading] = useState(false);
  // Handler functions for updating account information
  // useEffect(() => {
  //   setTypes(props?.types);
  // }, []);
  const handleAccountNameChange = (event) => {
    setAccountName(event.target.value);
  };

  const handleAccountNoChange = (event) => {
    setAccountNo(event.target.value);
  };

  const handleStatusChange = (event) => {
    setStatus(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setIsLoading(true);
    let data={
        account_name:accountName,
        account_no:accountNo,
        status:status,
        types:types
    }
    if(types.length == 0){
      toast.error("Please select type");
      setIsLoading(false);
      return false;
    }
    props.onSubmit(data);
  };

  const handleCheckboxChange = (value) => {
    if(types.includes(value)){
      setTypes(types.filter(item => item !== value))
    }else{
      setTypes([...types, value])
    }
    console.log(types)

  }

  return (
    <Modal isOpen={true} toggle={props.onClose}>
      <ModalHeader toggle={props.onClose}>
        <h4>Edit Payment Account </h4>
      </ModalHeader>
      <ModalBody>
        <Form>
          <FormGroup>
            <Label for="accountName">Account Name</Label>
            <Input
              type="text"
              name="accountName"
              id="accountName"
              value={accountName}
              onChange={handleAccountNameChange}
            />
          </FormGroup>
          <FormGroup>
            <Label for="accountNo">Account No</Label>
            <Input
              type="text"
              name="accountNo"
              id="accountNo"
              value={accountNo}
              onChange={handleAccountNoChange}
            />
          </FormGroup>
          <FormGroup>
            <Label for="type">Type</Label> 
             <Checkbox status={types?.includes("app")} label="app" forType="app" onClick={()=>handleCheckboxChange('app')}/>
            <Checkbox status={types?.includes("pos")} label="pos" forType="pos" onClick={()=>handleCheckboxChange('pos')}/> 
            
          </FormGroup>
          <FormGroup>
            <Label for="status">Status</Label>
            <Input
              type="select"
              name="status"
              id="status"
              value={status}
              onChange={handleStatusChange}
            >
              <option value="active">Active</option>
              <option value="disable">Disable</option>
            </Input>
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <button className="btn btn-default" onClick={props.onClose}>
          No
        </button>
        {isLoading == false && (
          <button className="btn btn-success" onClick={handleSubmit}>
            Save
          </button>
        )}
        {isLoading == true && (
          <button className="btn btn-success" disabled="disabled">
            Uploading...
          </button>
        )}
      </ModalFooter>
    </Modal>
  );
}

export default EditPaymentAccountModal;
